import { Slide, toast, ToastOptions } from 'react-toastify';

/**
 * Show sliding notification message
 * @param message
 * @param mode - defines notification's style
 */
export function showNotification(message: string, mode: 'info' | 'error') {
    const notificationOptions: ToastOptions = {
        autoClose: 2000,
        hideProgressBar: true,
        position: 'bottom-center',
        style: {
            minHeight: 'auto',
        },
        bodyStyle: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        transition: Slide,
    };

    toast[mode](message, notificationOptions);
}
